/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TradingPlanForQualityGates } from '../models/trading-plan-for-quality-gates';
import { PlanLinkageQGFilter } from '../models/plan-linkage-qgfilter';
@Injectable({
  providedIn: 'root',
})
class TradingPlansByIssuerAndInsiderNameService extends __BaseService {
  static readonly getTradingPlansByIssuerAndIssuerNamesPath = '/tradingPlans/fromNames';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param planLinkageQGFilter undefined
   * @return an array of trading plans required for quality gate
   */
  getTradingPlansByIssuerAndIssuerNamesResponse(planLinkageQGFilter: PlanLinkageQGFilter): __Observable<__StrictHttpResponse<Array<TradingPlanForQualityGates>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = planLinkageQGFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/tradingPlans/fromNames`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TradingPlanForQualityGates>>;
      })
    );
  }
  /**
   * @param planLinkageQGFilter undefined
   * @return an array of trading plans required for quality gate
   */
  getTradingPlansByIssuerAndIssuerNames(planLinkageQGFilter: PlanLinkageQGFilter): __Observable<Array<TradingPlanForQualityGates>> {
    return this.getTradingPlansByIssuerAndIssuerNamesResponse(planLinkageQGFilter).pipe(
      __map(_r => _r.body as Array<TradingPlanForQualityGates>)
    );
  }
}

module TradingPlansByIssuerAndInsiderNameService {
}

export { TradingPlansByIssuerAndInsiderNameService }
